package org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.media_model


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("listMedia")
    val listMedia: ListMedia?,
    @SerialName("__typename")
    val typename: String?
)